import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';


@Component({templateUrl: './qr-paylayout.component.html'})
export class QrPaylayoutComponent {

  constructor(
    private router: Router,

) {

}

}
